package com.bikompanion.ui.composables

import androidx.compose.runtime.Composable
import com.bikompanion.ui.theme.LocalDarkTheme

private const val LightPlateScale = 0.5f

/**
 * How opaque a glass plate is, given its dark-theme opacity.
 *
 * Light mode gets half. The light map is pale lines on near-white, so the refraction and colour
 * fringes under the glass have little contrast to work with, and a plate as thick as the dark
 * theme's hides what is left. The fringes can't be strengthened instead: dark mode already uses
 * Haze's maximum.
 */
@Composable
internal fun glassPlateAlpha(darkAlpha: Float): Float =
    if (LocalDarkTheme.current) darkAlpha else darkAlpha * LightPlateScale
